// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { InitDeprecatedResponse, InitData, InitResponse2, CheckData, CheckResponse2, GetAlertsResponse, GetContactInformationData, GetContactInformationResponse, UpdateContactInformationData, UpdateContactInformationResponse } from './types.gen';

export class BankIdService {
    /**
     * @returns InitResponse Success
     * @throws ApiError
     */
    public static initDeprecated(): CancelablePromise<InitDeprecatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/init'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sameDevice
     * @returns InitResponse Success
     * @throws ApiError
     */
    public static init(data: InitData): CancelablePromise<InitResponse2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/init/{sameDevice}',
            path: {
                sameDevice: data.sameDevice
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestId
     * @returns CheckResponse Success
     * @throws ApiError
     */
    public static check(data: CheckData): CancelablePromise<CheckResponse2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/check/{requestId}',
            path: {
                requestId: data.requestId
            }
        });
    }
    
}

export class AlertsService {
    /**
     * @returns AlertResponse Success
     * @throws ApiError
     */
    public static getAlerts(): CancelablePromise<GetAlertsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/alerts'
        });
    }
    
}

export class ContactInformationService {
    /**
     * @param data The data for the request.
     * @param data.requestId
     * @returns ContactInformation Success
     * @throws ApiError
     */
    public static getContactInformation(data: GetContactInformationData): CancelablePromise<GetContactInformationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/contactInfo/{requestId}',
            path: {
                requestId: data.requestId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestId
     * @param data.requestBody
     * @returns unknown Success
     * @throws ApiError
     */
    public static updateContactInformation(data: UpdateContactInformationData): CancelablePromise<UpdateContactInformationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contactInfo/{requestId}',
            path: {
                requestId: data.requestId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}